import axios from "axios";

export const gemsEndpoints = (builder) => ({
    getGemsRewardConfig: builder.query({
        query: ({ userGroup } = {}) => ({
            url: `/gems/reward-config${userGroup ? `?userGroup=${encodeURIComponent(userGroup)}` : ""}`,
            method: "get",
        }),
        providesTags: ["Gems"],
    }),
    updateGemsRewardConfig: builder.mutation({
        query: ({ rewardType, ...body }) => ({
            url: `/gems/reward-config/${encodeURIComponent(rewardType)}`,
            method: "put",
            body,
        }),
        invalidatesTags: ["Gems"],
    }),
    getGemsOverview: builder.query({
        query: ({ userGroup, startDate, endDate, period, rewardTypes }) => {
            const rewardTypesParam = Array.isArray(rewardTypes) ? rewardTypes.filter(Boolean).join(",") : rewardTypes;
            const rewardTypeParam = Array.isArray(rewardTypes) ? rewardTypes.find(Boolean) : rewardTypes;
            return ({
            url: `/gems/overview?userGroup=${encodeURIComponent(userGroup)}`
                + `${startDate ? `&startDate=${encodeURIComponent(startDate)}` : ""}`
                + `${endDate ? `&endDate=${encodeURIComponent(endDate)}` : ""}`
                + `${period ? `&period=${encodeURIComponent(period)}` : ""}`
                + `${rewardTypeParam ? `&rewardType=${encodeURIComponent(rewardTypeParam)}` : ""}`
                + `${rewardTypesParam ? `&rewardTypes=${encodeURIComponent(rewardTypesParam)}` : ""}`,
            method: "get",
            })
        },
        providesTags: ["Gems"],
    }),
    getGemsUserActivity: builder.query({
        query: ({ userGroup, startDate, endDate, rewardTypes }) => {
            const rewardTypesParam = Array.isArray(rewardTypes) ? rewardTypes.filter(Boolean).join(",") : rewardTypes;
            const rewardTypeParam = Array.isArray(rewardTypes) ? rewardTypes.find(Boolean) : rewardTypes;
            return ({
            url: `/gems/user-activity?userGroup=${encodeURIComponent(userGroup)}`
                + `${startDate ? `&startDate=${encodeURIComponent(startDate)}` : ""}`
                + `${endDate ? `&endDate=${encodeURIComponent(endDate)}` : ""}`
                + `${rewardTypeParam ? `&rewardType=${encodeURIComponent(rewardTypeParam)}` : ""}`
                + `${rewardTypesParam ? `&rewardTypes=${encodeURIComponent(rewardTypesParam)}` : ""}`,
            method: "get",
            })
        },
        providesTags: ["Gems"],
    }),
    getGemsCampaignPerformanceSummary: builder.query({
        query: ({ userGroup, startDate, endDate }) => ({
            url: `/gems/campaign-performance-summary?userGroup=${encodeURIComponent(userGroup)}`
                + `${startDate ? `&startDate=${encodeURIComponent(startDate)}` : ""}`
                + `${endDate ? `&endDate=${encodeURIComponent(endDate)}` : ""}`,
            method: "get",
        }),
        providesTags: ["Gems"],
    }),
    getGemsTopCampaigns: builder.query({
        query: ({ userGroup, startDate, endDate, limit }) => ({
            url: `/gems/top-campaigns?userGroup=${encodeURIComponent(userGroup)}`
                + `${limit ? `&limit=${encodeURIComponent(limit)}` : ""}`
                + `${startDate ? `&startDate=${encodeURIComponent(startDate)}` : ""}`
                + `${endDate ? `&endDate=${encodeURIComponent(endDate)}` : ""}`,
            method: "get",
        }),
        providesTags: ["Gems"],
    }),
    getGemsAccrualMonitoring: builder.query({
        query: ({ userGroup, startDate, endDate }) => ({
            url: `/gems/accrual-monitoring?userGroup=${encodeURIComponent(userGroup)}`
                + `${startDate ? `&startDate=${encodeURIComponent(startDate)}` : ""}`
                + `${endDate ? `&endDate=${encodeURIComponent(endDate)}` : ""}`,
            method: "get",
        }),
        providesTags: ["Gems"],
    }),
    getGemsAccrualRedemptionTotals: builder.query({
        query: ({ userGroup, startDate, endDate }) => ({
            url: `/gems/accrual-redemption-totals?userGroup=${encodeURIComponent(userGroup)}`
                + `${startDate ? `&startDate=${encodeURIComponent(startDate)}` : ""}`
                + `${endDate ? `&endDate=${encodeURIComponent(endDate)}` : ""}`,
            method: "get",
        }),
        providesTags: ["Gems"],
    }),
    getGemsTopUsers: builder.query({
        query: ({ userGroup, startDate, endDate, limit }) => ({
            url: `/gems/top-users?userGroup=${encodeURIComponent(userGroup)}`
                + `${limit ? `&limit=${encodeURIComponent(limit)}` : ""}`
                + `${startDate ? `&startDate=${encodeURIComponent(startDate)}` : ""}`
                + `${endDate ? `&endDate=${encodeURIComponent(endDate)}` : ""}`,
            method: "get",
        }),
        providesTags: ["Gems"],
    }),
    getGemsRewardAttempts: builder.query({
        query: ({ userGroup, startDate, endDate, status, rewardType, userId, limit }) => ({
            url: `/gems/reward-attempts?userGroup=${encodeURIComponent(userGroup)}`
                + `${startDate ? `&startDate=${encodeURIComponent(startDate)}` : ""}`
                + `${endDate ? `&endDate=${encodeURIComponent(endDate)}` : ""}`
                + `${status ? `&status=${encodeURIComponent(status)}` : ""}`
                + `${rewardType ? `&rewardType=${encodeURIComponent(rewardType)}` : ""}`
                + `${userId ? `&userId=${encodeURIComponent(userId)}` : ""}`
                + `${limit ? `&limit=${encodeURIComponent(limit)}` : ""}`,
            method: "get",
        }),
        providesTags: ["Gems"],
    }),
    getGemsAuditLogs: builder.query({
        query: ({ userGroup, startDate, endDate, adminId, action, entityType, entityId, limit }) => ({
            url: `/gems/audit-logs?userGroup=${encodeURIComponent(userGroup)}`
                + `${startDate ? `&startDate=${encodeURIComponent(startDate)}` : ""}`
                + `${endDate ? `&endDate=${encodeURIComponent(endDate)}` : ""}`
                + `${adminId ? `&adminId=${encodeURIComponent(adminId)}` : ""}`
                + `${action ? `&action=${encodeURIComponent(action)}` : ""}`
                + `${entityType ? `&entityType=${encodeURIComponent(entityType)}` : ""}`
                + `${entityId ? `&entityId=${encodeURIComponent(entityId)}` : ""}`
                + `${limit ? `&limit=${encodeURIComponent(limit)}` : ""}`,
            method: "get",
        }),
        providesTags: ["Gems"],
    }),
    getGemsExchangeRateActive: builder.query({
        query: ({ userGroup, currency }) => ({
            url: `/gems/exchange-rate/active?userGroup=${encodeURIComponent(userGroup)}`
                + `${currency ? `&currency=${encodeURIComponent(currency)}` : ""}`,
            method: "get",
        }),
        providesTags: ["Gems"],
    }),
    getGemsExchangeRateHistory: builder.query({
        query: ({ userGroup, currency }) => ({
            url: `/gems/exchange-rate/history?userGroup=${encodeURIComponent(userGroup)}`
                + `${currency ? `&currency=${encodeURIComponent(currency)}` : ""}`,
            method: "get",
        }),
        providesTags: ["Gems"],
    }),
    setGemsExchangeRate: builder.mutation({
        query: ({ userGroup, rate, currency, effectiveAt, meta }) => ({
            url: `/gems/exchange-rate?userGroup=${encodeURIComponent(userGroup)}`,
            method: "post",
            body: {
                rate,
                currency,
                ...(effectiveAt ? { effectiveAt } : {}),
                ...(meta ? { meta } : {}),
            },
        }),
        invalidatesTags: ["Gems"],
    }),
    getGemsUserBalance: builder.query({
        query: ({ userId, userGroup }) => ({
            url: `/gems/users/${encodeURIComponent(userId)}/balance`
                + `${userGroup ? `?userGroup=${encodeURIComponent(userGroup)}` : ""}`,
            method: "get",
        }),
        providesTags: ["Gems"],
    }),
    getGemsUserRewards: builder.query({
        query: ({ userId, userGroup, startDate, endDate }) => ({
            url: `/gems/users/${encodeURIComponent(userId)}/rewards`
                + `?${userGroup ? `userGroup=${encodeURIComponent(userGroup)}` : ""}`
                + `${userGroup && startDate ? "&" : ""}`
                + `${startDate ? `startDate=${encodeURIComponent(startDate)}` : ""}`
                + `${(userGroup || startDate) && endDate ? "&" : ""}`
                + `${endDate ? `endDate=${encodeURIComponent(endDate)}` : ""}`,
            method: "get",
        }),
        providesTags: ["Gems"],
    }),
    getGemsUserRedemptions: builder.query({
        query: ({ userId, userGroup, status, limit, offset, startDate, endDate }) => ({
            url: `/gems/users/${encodeURIComponent(userId)}/redemptions`
                + `?${userGroup ? `userGroup=${encodeURIComponent(userGroup)}` : ""}`
                + `${userGroup && status ? "&" : ""}`
                + `${status ? `status=${encodeURIComponent(status)}` : ""}`
                + `${(userGroup || status) && limit !== undefined && limit !== null ? "&" : ""}`
                + `${limit !== undefined && limit !== null ? `limit=${encodeURIComponent(limit)}` : ""}`
                + `${(userGroup || status || (limit !== undefined && limit !== null)) && offset !== undefined && offset !== null ? "&" : ""}`
                + `${offset !== undefined && offset !== null ? `offset=${encodeURIComponent(offset)}` : ""}`
                + `${(userGroup || status || (limit !== undefined && limit !== null) || (offset !== undefined && offset !== null)) && startDate ? "&" : ""}`
                + `${startDate ? `startDate=${encodeURIComponent(startDate)}` : ""}`
                + `${(userGroup || status || (limit !== undefined && limit !== null) || (offset !== undefined && offset !== null) || startDate) && endDate ? "&" : ""}`
                + `${endDate ? `endDate=${encodeURIComponent(endDate)}` : ""}`,
            method: "get",
        }),
        providesTags: ["Gems"],
    }),
    getGemsUserCampaigns: builder.query({
        query: ({ userId, userGroup }) => ({
            url: `/gems/users/${encodeURIComponent(userId)}/campaigns`
                + `${userGroup ? `?userGroup=${encodeURIComponent(userGroup)}` : ""}`,
            method: "get",
        }),
        providesTags: ["Gems"],
    }),
    generateGemsReport: builder.mutation({
        query: ({ userGroup, startDate, endDate, reportType, campaignStatus, download = true }) => {
            const params = new URLSearchParams();

            if (userGroup) params.set("userGroup", userGroup);
            if (reportType) params.set("reportType", reportType);
            if (startDate) params.set("startDate", startDate);
            if (endDate) params.set("endDate", endDate);
            if (reportType === "campaigns" && campaignStatus) params.set("campaignStatus", campaignStatus);
            params.set("download", String(download));

            return {
                url: `/gems/report?${params.toString()}`,
                method: "get",
                responseType: "blob",
            };
        },
    }),
    submitGemsReportExport: builder.mutation({
        query: (filters = {}) => {
            const queryParams = new URLSearchParams();

            Object.entries(filters).forEach(([key, value]) => {
                if (value === undefined || value === null || value === "") {
                    return;
                }

                if (Array.isArray(value)) {
                    if (value.length === 0) return;
                    queryParams.append(key, value.join(","));
                    return;
                }

                queryParams.append(key, value);
            });

            const queryString = queryParams.toString();

            return {
                url: `/gems/report/export${queryString ? `?${queryString}` : ""}`,
                method: "post",
                body: filters,
            };
        },
    }),
    pollGemsReportExport: builder.mutation({
        async queryFn({ jobId, page = 1, limit = 10000 } = {}) {
            try {
                const response = await axios.get(`/gems/report/export/${jobId}`, {
                    params: { page, limit },
                    validateStatus: () => true,
                });

                if (response.status === 200 || response.status === 202) {
                    return {
                        data: {
                            status: response.status,
                            payload: response.data,
                        },
                    };
                }

                return {
                    error: {
                        status: response.status,
                        data: response.data?.error || response.statusText || "Gems export failed",
                    },
                };
            } catch (error) {
                return {
                    error: {
                        status: error?.response?.status,
                        data: error?.response?.data?.error || error?.message || "Gems export failed",
                    },
                };
            }
        },
    }),
});
